import { useQuery } from "@tanstack/react-query";
import { workspaceQuery } from "../../features/workspace/queries";

/**
 * The workspace named in the URL, for the shell (switcher, acting banner). Disabled without an id.
 * A failed lookup (missing or not allowed) makes the shell hide the switcher instead of showing a bad id.
 */
export function useShellWorkspace(workspaceId: string | undefined) {
  return useQuery({
    ...workspaceQuery(workspaceId ?? ""),
    enabled: Boolean(workspaceId),
    retry: false,
  });
}
